<template>
  <div>
    <div class="default-library-video-card white rounded-10 overflow-hidden w-100 h-auto">
      <!-- TOP -->
      <div class="top position-relative w-100">
        <!-- OVERLAY -->
        <div
          class="position-absolute w-100 h-100"
          :class="show_loader ? 'skeleton-loader' : 'brand_white_bg'"
        ></div>
      </div>

      <!-- BOTTOM -->
      <div class="bottom">
        <!-- VIDEO TITLE -->
        <div class="video-title" :class="show_loader ? 'skeleton-loader' : 'brand_white_bg'"></div>
        <!-- VIDEO META -->
        <div class="video-meta" :class="show_loader ? 'skeleton-loader' : 'brand_white_bg'"></div>
        <!-- VIDEO TAG -->
        <div class="video-tag" :class="show_loader ? 'skeleton-loader' : 'brand_white_bg'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultVideoCard",

  props: {
    show_loader: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang='scss' scoped>
.default-library-video-card {
  margin-bottom: 30px;
  transition: all 0.4s ease-in-out;

  .top {
    height: 130px;

    @include breakpoint_max(lg) {
      height: 120px;
    }

    @include breakpoint_max(md) {
      height: 140px;
    }
  }

  .bottom {
    padding: 15px 15px 20px;

    @include breakpoint_max(lg) {
      padding: 10px 15px;
    }

    @include breakpoint_max(xs) {
      padding: 8px 10px 12px;
    }

    .video-title {
      width: 70%;
      height: 20px;
      margin-bottom: 3px;
    }

    .video-meta {
      width: 90%;
      height: 16px;
      margin-bottom: 15px;
    }

    .video-tag {
      width: 40%;
      height: 13px;
    }
  }
}
</style>
